import { render, staticRenderFns } from "./TemplateOrderUpload.vue?vue&type=template&id=54bbec31&scoped=true"
import script from "./TemplateOrderUpload.vue?vue&type=script&lang=js"
export * from "./TemplateOrderUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bbec31",
  null
  
)

export default component.exports